module.exports = __webpack_public_path__ + "img/PGR_A01_back_en.5a8c9ed4.png";